import React from "react";
import { Box, Checkbox, Typography } from "@material-ui/core";
import { Kpay } from "../../../assets/images/paymentMethods";
import { CheckIcon } from "../CheckIcon/CheckIcon";
import { Translate as T } from "react-localize-redux";
import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (theme) { return ({
    check: {
        padding: 0,
    },
    content: {
        border: "1px solid #CBD5E0",
        margin: theme.spacing(1, 0),
        minHeight: theme.spacing(4.5),
    },
    label: {
        color: "#6D7781",
        fontSize: "12px",
        padding: theme.spacing(0, 1),
    },
    selected: {
        backgroundColor: "rgba(36, 63, 142, 0.05)",
    },
    svg: {
        height: theme.spacing(4),
        width: theme.spacing(6.2),
        paddingTop: 5,
    },
}); });
var KPayCheck = function (_a) {
    var handlerChange = _a.handlerChange, isChecked = _a.isChecked;
    var classes = useStyles();
    return (React.createElement(Box, { display: "flex", border: 1, flexDirection: "row", alignItems: "center", borderRadius: 4, p: 1, className: classes.content + " " + (isChecked ? classes.selected : "") },
        React.createElement(Checkbox, { className: classes.check, onChange: function (event) { return handlerChange(event.target.checked); }, icon: React.createElement(CheckIcon, { size: 28 }), checkedIcon: React.createElement(CheckIcon, { size: 28, isChecked: true, color: "#243F8E" }) }),
        React.createElement(Box, { display: "flex", justifyContent: "center", height: "100%" },
            React.createElement(Typography, { variant: "subtitle1", className: classes.label },
                React.createElement(T, { id: "saveKpayLabel" }))),
        React.createElement(Kpay, { className: classes.svg })));
};
export default KPayCheck;
